import { attr } from '@ember-data/model';
import BaseModel, { type IResourceName } from 'volta/models/base-model';
import type { IUpdateSourceMatchingRule } from 'volta/models/types/source-matching-rule'; // Adjust the path as needed
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';
import { _normalize, collectionCommand, resourceCommand as command } from 'volta/utils/api';
import { Type } from '@warp-drive/core-types/symbols';

export const SourceMatchingRuleResourceName: IResourceName = {
  singular: 'sourceMatchingRule',
  plural: 'sourceMatchingRules'
};

export enum SourceMatchingRuleCommands {
  CreateSourceMatchingRule = 'CreateSourceMatchingRule',
  UpdateSourceMatchingRule = 'UpdateSourceMatchingRule',
  DeleteSourceMatchingRule = 'DeleteSourceMatchingRule',
  ReorderSourceMatchingRules = 'ReorderSourceMatchingRules'
}

export default class SourceMatchingRule extends BaseModel {
  // Collection Commands
  // ~~~~~
  static createSourceMatchingRule = collectionCommand<
    IUpdateSourceMatchingRule,
    SourceMatchingRule,
    typeof SourceMatchingRule
  >(SourceMatchingRuleCommands.CreateSourceMatchingRule);

  static reorderSourceMatchingRules = collectionCommand<
    { ids: string[] },
    string[],
    typeof SourceMatchingRule
  >(SourceMatchingRuleCommands.ReorderSourceMatchingRules);

  // Attributes
  // ~~~~~

  @attr('string')
  name!: string;

  @attr('string')
  description?: string;

  @attr('number')
  ruleOrder!: number;

  @attr('number')
  transactionCount!: number;

  @attr('number')
  orderCount!: number;

  @attr({
    defaultValue: () => ({})
  })
  filters!: IJsonApiQuery['filter'];

  @attr('string')
  sourceId!: string;

  @attr('boolean', { defaultValue: true })
  enabled!: boolean;

  toCmd(): IUpdateSourceMatchingRule {
    return {
      name: this.name,
      description: this.description,
      filters: this.filters,
      sourceId: this.sourceId,
      enabled: this.enabled
    };
  }

  // Instance Commands
  // ~~~~~

  updateSourceMatchingRule = command<IUpdateSourceMatchingRule, SourceMatchingRule>(
    SourceMatchingRuleCommands.UpdateSourceMatchingRule
  );

  deleteSourceMatchingRule = command<any, SourceMatchingRule>(
    SourceMatchingRuleCommands.DeleteSourceMatchingRule
  );

  [Type] = 'source-matching-rule' as const;
}
